import { StyledKeylineDiv, StyledTagLabel } from '../../../../ui/Styled';

import { TariffItem } from '.';

// Check if the recommended tariff is the users current tariff
const isBestTariff = (recommendedTariff) =>
  recommendedTariff.tariff_combination.tariff_standard_combination_id === 'current_set_tariff';

const RecommendedTariff = ({ recommendedTariffs, hasTariffBeenRecentlyUpdated }) => {
  // The recommended tariff is the first result in the array
  const recommendedTariff = recommendedTariffs[0];

  // Show "stay on current tariff" message if:
  // 1. The recommended tariff is the current tariff (user hasn't switched), OR
  // 2. The user has recently switched tariffs (indicating they're on a new tariff)
  // Note: These are mutually exclusive - if user has switched,
  // there is a chance the recommended tariff may not be the current tariff
  const shouldShowStayMessage = hasTariffBeenRecentlyUpdated || isBestTariff(recommendedTariff);

  return (
    <>
      <StyledTagLabel.Recommended>Recommended tariff for you:</StyledTagLabel.Recommended>
      <StyledKeylineDiv.Recommended className="mb-4">
        {shouldShowStayMessage ? (
          <strong>
            Stay on your current tariff, we'll let you know when we think you could be on a better tariff.
          </strong>
        ) : (
          <TariffItem tariff={recommendedTariff} showSupplier={true} />
        )}
      </StyledKeylineDiv.Recommended>
    </>
  );
};

export default RecommendedTariff;
